module.exports = __webpack_public_path__ + "img/imgstep5.d3c302b7.svg";